// extracted by mini-css-extract-plugin
export var carrierNotice = "_l6-5";
export var carrierNoticePlaceholder = "_l6-6";
export var deliveryRow = "_l6-c";
export var fixedHeight = "_l6-4";
export var freightLogo = "_l6-b";
export var fullWidth = "_l6-3";
export var priceColumn = "_l6-7";
export var radioSelected = "_l6-9";
export var radioUnselected = "_l6-8";
export var selectedOption = "_l6-2";
export var selectedOptionContainer = "_l6-1";
export var selection = "_l6-0";
export var tallSkeletonText = "_l6-a";